<template>
  <div>
    <!--页面大于750px是使用的公共头部-->
    <div class="HeadTop">
      <div class="headTitle">
        <div class="headTitleLine">
          <img src="../../assets/images/home/link/facebook.png"/>
          <img src="../../assets/images/home/link/line.png"/>
          <img src="../../assets/images/home/link/youtube.png"/>
          <img src="../../assets/images/home/link/sina.png"/>
          <img src="../../assets/images/home/link/weixin.png"/>
        </div>
        <div class="headTitleImg">
          <img src="http://hm.isdg.cn/logo3.png">
        </div>
        <div class="headTitleLine"></div>
      </div>
      <p class="headline"></p>
      <div class="headNav">
        <div class="headNavLeft"></div>
        <ul class="headNavCenter">
          <li>
            <router-link to="/home" active-class="selected">
              <span>トップページ</span>
            </router-link>
          </li>
          <li></li>
          <li>
            <router-link to="/brand" active-class="selected">
              <span>会社情報</span>
            </router-link>
          </li>
          <li></li>
          <li>
            <router-link to="/404" active-class="selected">
              <span>個人情報</span>
            </router-link>
          </li>
        </ul>
        <div class="headNavRight">
          <button v-show="this.islogin" class="successSpan" @click="Exit" id="label">おもいたつ</button>
          <span class="noSpan" v-show="!this.islogin">
          <router-link to="/login"><img src="../../assets/images/Head/h_user.png"></router-link></span>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
  import {getUserInfo} from './../../api/interface/users';
  import {bus} from '../../main'
  export default{
    name: "",
    data(){
      return {
        msg: "",
        istext: false,
        islogin: localStorage.getItem('token') || "",
        userInfo: {},
        head_url: localStorage.getItem('headImg') || ""
      }
    },
    beforeMount(){
      bus.$on("state", (token) => {
        this.islogin = token;
      });
      bus.$on("headImg", (Img) => {
        this.head_url = Img;
      });
//      this.scrollTop();
    },
    methods: {
      ExitShow(){
        this.istext = !this.istext
      },
      Exit(){
        this.islogin = "";
        localStorage.clear('token');
        localStorage.clear('headImg');
        this.$router.push({path: "/login"})
      },
    },
    components: {}
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .HeadTop {
      display: none;
    }
  }

  @media screen and(min-width: $P750screen) {
    .HeadTop {
      .headTitle {
        width: 100%;
        height: 120px;
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        .headTitleLine {
          width: 240px;
          height: 120px;
          display: flex;
          align-items: flex-end;
          justify-content: flex-start;
          img {
            margin-bottom: 10px;
            width: 20px;
            height: 20px;
            margin-left: 10px;
          }
        }
        .headTitleImg {
          width: 251px;
          height: 50px;
          margin: 35px auto;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .headline {
        width: 100%;
        height: 2px;
        border-bottom: 2px solid #e3e3e3;
      }
      .headNav {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        height: 60px;
        display: flex;
        justify-content: space-between;
        background-color: #f8f8f8;
        .headNavCenter {
          height: 60px;
          line-height: 60px;
          display: flex;
          li:nth-child(even) {
            width: 2px;
            height: 30px;
            margin: 15px 20px ;
            background-color: #e3e3e3;
          }
          li:nth-child(odd) {
            width: 108px;
            text-align: center;
            /*background-color: #8ec321;*/
          }
          a {
            color: black;
            text-decoration: none;
          }
          .selected > span {
            color: $navcolor;
          }
        }
        .headNavRight, .headNavLeft {
          height: 60px;
          width: 150px;
          /*background-color: #960;*/
          display: flex;
          justify-content: space-between;
          .noSpan, .noCart {
            margin-top: 15px;
            display: inline-block;
            margin-right: 20px;
            img {
              height: 30px;
              width: 30px;
            }
          }
          .successSpan {
            height: 40px;
            margin: 10px 20px 10px 0;
            line-height: 40px;
            text-align: center;
            outline: none;
            border: none;
            background-color: #f6f7f9;
          }
        }
      }
    }
  }


</style>




// WEBPACK FOOTER //
// src/views/common/Head.vue